import './live-chat.css';

import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import CollapseButton from '@/presentation/screens/classroom/components/side-navigation/collapse-button/collapse-button';
import { ButtonContainer } from '@/presentation/shared-components/button';

import { LiveViewModel } from '../../live.vm';

type LiveChatParams = {
  showChat: boolean;
  chatUrl: URL;
};

const LiveChatContainer: React.FC<LiveChatParams> = ({ showChat, chatUrl }: LiveChatParams) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const vm = useViewModel(LiveViewModel);

  const hideLandscapeChat = window.matchMedia(
    'screen and (orientation: landscape) and (max-width: 1024px)',
  ).matches;

  const showCollapseButton =
    !window.matchMedia('(min-width:768px)').matches || hideLandscapeChat ? 'hidden' : '';

  const showChatComponentHandler = () => {
    if (showChat) {
      return (
        <div className="chat-iframe-container">
          <iframe className={`chat-iframe`} src={chatUrl.href} />
          <ButtonContainer
            className="mobile-menu"
            onClick={() => vm.setShowFullscreenChat(false)}
            ariaLabel="Ocultar chat"
          >
            <span>Ocultar chat</span>
          </ButtonContainer>
        </div>
      );
    }

    return (
      <div className="chat-placeholder">
        <h4>{'O chat iniciará com a aula'}</h4>
        <ul>
          <li>
            <p>
              {
                'Ofensas, assédios, palavrões e mensagens repetidas não são tolerados, eles podem gerar o banimento ao chat e cancelamento da sua conta.'
              }
            </p>
          </li>
          <li>
            <p>{'Apelidos ofensivos no lugar do nome podem gerar banimento aos chats das aulas'}</p>
          </li>
          <li>
            <p>
              {
                'Incentivamos o debate saudável, mas não é permitida a defesa de partidos, ideologias ou políticos'
              }
            </p>
          </li>
          <li>
            <p>
              {
                'Não divulgue perfis das sua redes sociais, seu telefone ou grupo de mensagens. É pela sua segurança!'
              }
            </p>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <div className="live-chat-container">
      {!showCollapseButton && (
        <CollapseButton handleCollapse={setCollapsed} collapsed={collapsed} />
      )}
      <div className={`live-chat  ${collapsed && !hideLandscapeChat ? 'desktop-hidden' : ''}`}>
        <div className={`live-chat-content  ${collapsed ? 'desktop-hidden' : ''}`}>
          {showChatComponentHandler()}
        </div>
      </div>
    </div>
  );
};

export default observer(LiveChatContainer);
